import {React, useContext}from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ThemeContext from '../../context/ThemeContext';

import {
  faLinkedin,
  faGoogle,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

import "./Footer.css";


const Footer = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <div className={`footer ${theme}`}>
      <div className="footer-content">
        <p className={`copy ${theme}`}>&copy; <span id="date">{new Date().getFullYear()}</span> Atefe Fazeli. All rights reserved.</p>
        <nav className="social-media">
          <ul>
            <li>
              <a
                href="https://www.linkedin.com/in/atefehfazeli"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faLinkedin}
                  className={`custom-icon ${theme}`}
                  title="linkedin"
                
                />
              </a>
            </li>
            <li>
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=atefefazeli583@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faGoogle}
                  className={`custom-icon ${theme}`}
                  title="gmail"
                />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/atefe__fazeli?igsh=eXJrbnUzbHVzd2ox"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  className={`custom-icon ${theme}`}
                  title="instagram"
        
                />
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div className={`footer-info ${theme}`}>
       
        <p className={`copy ${theme}`}>
          Website created by <a href="https://github.com/aminpirakand" target="_blank" rel="noopener noreferrer">Amin Pirakand</a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
